// @flow weak

import _ from 'lodash';
import { connect } from 'react-redux';

import * as Account from 'app/entities/Account';
import * as Zap from 'app/entities/Zap';
import AppNavAccountSwitcherDropdown from 'app/common/components/AppNavAccountSwitcherDropdown';
import MaybeLoad from 'app/common/components/MaybeLoad';
import hocify from 'app/common/components/hocify';
import { buildAutoFromLink } from 'app/zap-mover/Selectors';

const items = [
  (currentAccount, state) => {
    const href = buildAutoFromLink(Account.selectors.id(currentAccount), state);
    return !href
      ? null
      : {
          label: 'Move Zaps',
          href,
          icon: 'move',
        };
  },
  currentAccount =>
    Account.selectors.isOrWasTeam(currentAccount) && {
      label: 'Team Settings',
      href: '/app/settings/team',
      icon: 'cog-gear',
    },
  currentAccount =>
    !Account.selectors.isOrWasTeam(currentAccount) && {
      label: 'Start a Team Trial',
      href: '/app/team-account-setup',
      icon: 'team',
    },
];

const mapStateToProps = state => {
  const currentAccount = Account.selectors.all.currentAccount(state);
  return {
    accountId: Account.selectors.id(currentAccount),
    accountName: Account.selectors.teamName(currentAccount),
    items: items
      .map(buildItem => {
        return buildItem(currentAccount, state);
      })
      .filter(Boolean),
  };
};

const mapDispatchToProps = dispatch => ({
  onLoad() {
    dispatch(Zap.actions.loadUsage());
  },
});

export default _.flowRight(
  connect(mapStateToProps, mapDispatchToProps),
  hocify(MaybeLoad)
)(AppNavAccountSwitcherDropdown);
